import EmailInput from "./EmailInput";
import PhoneInput from "./PhoneInput";
import type { IContactInfoProps } from "../../types";
import { Radio, FormLabel, RadioGroup, FormControl, FormControlLabel } from "@mui/material";

export default function ContactInfo(props: IContactInfoProps) {
  const {
    contactForm,
    text,
    isSMS,
    email,
    phoneNumber,
    dialCode,
    errors,
    styles,
    handleChangeContactInfo,
    handleEmailChange,
    handleAreaCodeChange,
    handlePhoneChange,
    handleIsSMSChange,
  } = props;

  return (
    <>
      <FormControl fullWidth sx={{ alignItems: "center" }}>
        <FormLabel>{text.contactVia}</FormLabel>

        <RadioGroup row value={contactForm} onChange={handleChangeContactInfo}>
          <FormControlLabel value="email" control={<Radio />} label={text.emailLabel} />

          <FormControlLabel value="phone" control={<Radio />} label={text.phone} />
        </RadioGroup>
      </FormControl>

      {contactForm === "email" ? (
        <EmailInput
          label={text.emailLabel}
          helperText={text.emailExample}
          email={email}
          error={errors.email}
          styles={styles}
          handleEmailChange={handleEmailChange}
        />
      ) : null}

      {contactForm === "phone" ? (
        <PhoneInput
          text={text}
          isSMS={isSMS}
          phoneNumber={phoneNumber}
          dialCode={dialCode}
          error={errors.phoneNumber}
          styles={styles}
          handleAreaCodeChange={handleAreaCodeChange}
          handlePhoneChange={handlePhoneChange}
          handleIsSMSChange={handleIsSMSChange}
        />
      ) : null}
    </>
  );
}
